export function pluralize(singleForm: string, amount: number, pluralForm = `${singleForm}s`): string {
    return amount === 1 ? singleForm : pluralForm;
}
